/* eslint-disable no-plusplus */

import { Slot } from "../panels/ChooseDatePanel/types";

// eslint-disable-next-line import/prefer-default-export
export const getValidDatesForQueue = (slots: Slot[], exceptions: number[]) => {
  if (!exceptions.length) {
    return slots;
  }
  const validSlots: Slot[] = [];
  for (let index = 0; index < slots.length; index++) {
    const slot = slots[index];
    const currentTime = new Date(slot.visitTimeStr).getTime();
    const isValidSlot = !exceptions.some(
      (exception) => exception === currentTime
    );
    if (isValidSlot) {
      validSlots.push(slot);
    }
  }
  return validSlots;
};
